// extracted by mini-css-extract-plugin
export var border = "_z-8";
export var brand = "_z-t";
export var button = "_z-l";
export var center = "_z-a";
export var centered = "_z-6";
export var closeButton = "_z-c";
export var disabledWrapper = "_z-m";
export var error = "_z-p";
export var extraLarge = "_z-4";
export var extraSmall = "_z-1";
export var fill = "_z-i";
export var footer = "_z-h";
export var footerAction = "_z-j";
export var footerButtons = "_z-k";
export var header = "_z-7";
export var headerWithClose = "_z-d";
export var icon = "_z-o";
export var info = "_z-s";
export var inline = "_z-9";
export var large = "_z-3";
export var main = "_z-e";
export var modal = "_z-0";
export var nearFull = "_z-5";
export var neutral = "_z-u";
export var noPadding = "_z-g";
export var none = "_z-v";
export var scrollable = "_z-f";
export var small = "_z-2";
export var success = "_z-r";
export var tight = "_z-n";
export var titleIcon = "_z-b";
export var warn = "_z-q";